import React from 'react';

interface UserAvatarProps {
  name: string;
  className?: string;
  isSpeaking?: boolean;
  style?: React.CSSProperties; 
}

export default function UserAvatarIcon({ 
  name, 
  className = '', 
  isSpeaking = false,
  style = {}, 
}: UserAvatarProps) {
  const initials = name
    ? (name.trim().charAt(0) + name.trim().slice(-1)).toUpperCase()
    : '';

  return (
    <div
      className={`avatar ${isSpeaking ?"speaking" : ''} ${className}`}
      aria-label={`User avatar for ${name}`}
      role="img"
      style={style} 
    >
      {initials}
    </div>
  );
}
